import {
	IndustryCategories,
	IndustryCategory,
	IndustryOption,
} from 'common/services/analytics/tractionAnalytics';
import i18n from 'services/localization';

export const getIndustryCategoryOptions = (): IndustryOption[] => [
	{
		type: IndustryCategories.ADVENTURE_OUTDOORS,
		text: i18n.t('register.industryCategoryAdventureOutdoors', 'Adventure / Outdoors'),
	},
	{
		type: IndustryCategories.BIKES_SCOOTERS,
		text: i18n.t('register.industryCategoryBikesScooters', 'Bikes / Scooters'),
	},
	{
		type: IndustryCategories.WATERSPORTS,
		text: i18n.t('register.industryCategoryWatersports', 'Watersports'),
	},
	{
		type: IndustryCategories.WINTERSPORTS,
		text: i18n.t('register.industryCategoryWintersports', 'Wintersports'),
	},
	{
		type: IndustryCategories.OTHER_SPORTS,
		text: i18n.t('register.industryCategoryOtherSports', 'Other Sports'),
	},
	{
		type: IndustryCategories.VEHICLES_BOATS,
		text: i18n.t('register.industryCategoryVehicleBoats', 'Vehicles / Boats'),
	},
	{
		type: IndustryCategories.CLOTHING_FASHION,
		text: i18n.t('register.industryCategoryClothingFashion', 'Clothing / Fashion'),
	},
	{
		type: IndustryCategories.TOOLS_CONSTRUCTION,
		text: i18n.t('register.industryCategoryToolsConstruction', 'Tools / Construction'),
	},
	{
		type: IndustryCategories.CAMERA_AV,
		text: i18n.t('register.industryCategoryCameraAv', 'Camera / AV'),
	},
	{
		type: IndustryCategories.EVENTS_DECOR,
		text: i18n.t('register.industryCategoryEventsDecor', 'Events / Decor'),
	},
	{
		type: IndustryCategories.FURNITURE,
		text: i18n.t('register.industryCategoryFurniture', 'Furniture'),
	},
	{
		type: IndustryCategories.TECH_ELECTRONICS,
		text: i18n.t('register.industryCategoryTechElectronics', 'Tech / Electronics'),
	},
	{
		type: IndustryCategories.BABY_MATERNITY,
		text: i18n.t('register.industryCategoryBabyMaternity', 'Baby / Maternity'),
	},
	{
		type: IndustryCategories.GUIDED_ACTIVITIES_TOURS,
		text: i18n.t('register.industryCategoryGuidesTours', 'Guided activities / Tours'),
	},
	{
		type: IndustryCategories.ENTRANCE_TICKETS,
		text: i18n.t(
			'register.industryCategoryEntranceTickets',
			'Entrance tickets (e.g. lift, area, park)',
		),
	},
	{
		type: IndustryCategories['RETAIL_E-COMMERCE'],
		text: i18n.t('register.industryCategoryRetailEcommerce', 'Retail, e-commerce'),
	},
	{
		type: IndustryCategories['RETAIL_IN-STORE'],
		text: i18n.t('register.industryCategoryRetailInStore', 'Retail, in-store'),
	},
	{
		type: IndustryCategories.OTHER,
		text: i18n.t('register.industryCategoryOther', 'Other'),
	},
];

export const getIndustryCategoryLabel = (category: IndustryCategory) =>
	getIndustryCategoryOptions().find((industry) => industry.type === category)?.text;

export const getCtaContent = () => [
	{
		title: i18n.t('register.ctaTitleFirst', 'Start for free'),
		text: i18n.t('register.ctaTextFirst', 'Get started with Rentle Free, choose to upgrade later'),
	},
	{
		title: i18n.t('register.ctaTitleSecond', 'Get started in minutes'),
		text: i18n.t('register.ctaTextSecond', 'No technical skills required.'),
	},
	{
		title: i18n.t('register.ctaTitleThird', 'Start selling online'),
		text: i18n.t(
			'register.ctaTextThird',
			'Bring your idea to life with the tools you need to start selling online.',
		),
	},
];
